import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader } from "../../../components";
import {
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Snackbar,
  Alert,
  Autocomplete,
  Paper,
} from "@mui/material";
import { Col, Row, Form } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";

const UbahSurveyor = () => {
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [kodeSurveyor, setKodeSurveyor] = useState("");
  const [namaSurveyor, setNamaSurveyor] = useState("");
  const [jenisSurveyor, setJenisSurveyor] = useState("");
  const [jenisSurveyorLama, setJenisSurveyorLama] = useState("");
  const [teleponSurveyor, setTeleponSurveyor] = useState("");
  const [kodeHeadSurveyor, setKodeHeadSurveyor] = useState("");
  const [kodeHeadSurveyorLama, setKodeHeadSurveyorLama] = useState("");

  const [headSurveyors, setHeadSurveyors] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const [validated, setValidated] = useState(false);
  const { screenSize } = useStateContext();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const headSurveyorOptions = headSurveyors.map((headSurveyor) => ({
    value: headSurveyor.kodeHeadSurveyor,
    label: `${headSurveyor.kodeHeadSurveyor} - ${headSurveyor.namaHeadSurveyor}`,
  }));

  useEffect(() => {
    getSurveyorById();
    getHeadSurveyor();
  }, []);

  const getSurveyorById = async () => {
    setLoading(true);
    const pickedSurveyor = await axios.post(`${tempUrl}/surveyors/${id}`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setKodeSurveyor(pickedSurveyor.data.kodeSurveyor);
    setNamaSurveyor(pickedSurveyor.data.namaSurveyor);
    setJenisSurveyor(pickedSurveyor.data.jenisSurveyor);
    setJenisSurveyorLama(pickedSurveyor.data.jenisSurveyor);
    setTeleponSurveyor(pickedSurveyor.data.teleponSurveyor);
    setKodeHeadSurveyor(
      `${pickedSurveyor.data.kodeHeadSurveyor.kodeHeadSurveyor} - ${pickedSurveyor.data.kodeHeadSurveyor.namaHeadSurveyor}`
    );
    setKodeHeadSurveyorLama(
      `${pickedSurveyor.data.kodeHeadSurveyor.kodeHeadSurveyor} - ${pickedSurveyor.data.kodeHeadSurveyor.namaHeadSurveyor}`
    );
    setLoading(false);
  };

  const getHeadSurveyor = async () => {
    setLoading(true);
    const allHeadSurveyors = await axios.post(`${tempUrl}/headSurveyors`, {
      id: user._id,
      token: user.token,
      kodeCabang: user.cabang._id,
    });
    setHeadSurveyors(allHeadSurveyors.data);
    setLoading(false);
  };

  const updateSurveyor = async (e) => {
    e.preventDefault();
    var date = new Date();
    var current_date =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    var current_time =
      date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

    let isFailedValidation =
      namaSurveyor.length === 0 ||
      jenisSurveyor.length === 0 ||
      kodeHeadSurveyor.length === 0;
    if (isFailedValidation) {
      setError(true);
      setOpen(!open);
    } else {
      try {
        setLoading(true);
        const tempHeadSurveyor = await axios.post(
          `${tempUrl}/headSurveyorByKode`,
          {
            kodeHeadSurveyor: kodeHeadSurveyor.split(" -", 1)[0],
            id: user._id,
            token: user.token,
            kodeCabang: user.cabang._id,
          }
        );
        await axios.post(`${tempUrl}/updateSurveyor/${id}`, {
          namaSurveyor,
          jenisSurveyor,
          teleponSurveyor,
          kodeHeadSurveyor: tempHeadSurveyor.data._id,
          tglUpdate: current_date,
          jamUpdate: current_time,
          userUpdate: user.username,
          kodeCabang: user.cabang._id,
          id: user._id,
          token: user.token,
        });
        setLoading(false);
        navigate(`/surveyor/${id}`);
      } catch (error) {
        if (error.response.status == 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        console.log(error);
      }
    }
    setValidated(true);
  };

  const jenisSurveyorOption = [{ label: "CMO" }, { label: "SURVEYOR" }];

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Box>
      <Typography color="#757575">Master</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Ubah Surveyor
      </Typography>
      <Divider sx={dividerStyle} />
      <Paper sx={contentContainer} elevation={12}>
        <Form noValidate validated={validated} onSubmit={updateSurveyor}>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kode Surveyor :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kodeSurveyor} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama Surveyor <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={namaSurveyor}
                        required
                        onChange={(e) =>
                          setNamaSurveyor(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Nama Surveyor harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Telepon :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={teleponSurveyor}
                        type="number"
                        onChange={(e) =>
                          setTeleponSurveyor(e.target.value.toUpperCase())
                        }
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Jenis Surveyor <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Autocomplete
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        options={jenisSurveyorOption}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            error={error && jenisSurveyor.length === 0 && true}
                            helperText={
                              error &&
                              jenisSurveyor.length === 0 &&
                              "Jenis harus diisi!"
                            }
                            {...params}
                          />
                        )}
                        onInputChange={(e, value) => setJenisSurveyor(value)}
                        inputValue={jenisSurveyor}
                        onChange={(e, value) => setJenisSurveyorLama(value)}
                        value={jenisSurveyorLama}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kode Head Surveyor <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Autocomplete
                        size="small"
                        disablePortal
                        id="combo-box-demo"
                        options={headSurveyorOptions}
                        renderInput={(params) => (
                          <TextField
                            size="small"
                            error={
                              error && kodeHeadSurveyor.length === 0 && true
                            }
                            helperText={
                              error &&
                              kodeHeadSurveyor.length === 0 &&
                              "Kode Head Surveyor harus diisi!"
                            }
                            {...params}
                          />
                        )}
                        onInputChange={(e, value) => setKodeHeadSurveyor(value)}
                        inputValue={kodeHeadSurveyor}
                        onChange={(e, value) => setKodeHeadSurveyorLama(value)}
                        value={kodeHeadSurveyorLama}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>
          <Box sx={spacingTop}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate("/surveyor")}
              sx={{ marginRight: 2 }}
            >
              {"< Kembali"}
            </Button>
            <Button variant="contained" startIcon={<EditIcon />} type="submit">
              Ubah
            </Button>
          </Box>
        </Form>
      </Paper>
      <Divider sx={dividerStyle} />
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
};

export default UbahSurveyor;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  mt: 2,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const contentContainer = {
  p: 3,
  pt: 1,
  mt: 2,
  backgroundColor: Colors.grey100,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};
